import React, { useEffect, useState } from 'react';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Modal } from "@mui/material";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { getClaimDetails } from "../../store/action/claim";
import TiersSection from "../sinistreSection/tiersSection";
import PoliceSection from "../sinistreSection/policeSection";
import VehiculeSection from "../sinistreSection/vehiculeSection";
import ImagesTab from "../sinistreSection/photoSection";
import ExpertisesSection from "../sinistreSection/expertisesSection";
import PriseEnChargeSection from "../sinistreSection/PriseEnChargeSection";
import ReglementHonorairesSection from "../sinistreSection/ReglementHonorairesSection";
import HistoriqueSection from "../sinistreSection/historiqueSection";
import DocSection from "../sinistreSection/docSection";
import InformationSinistre from "../sinistreSection/informationSinistre";

const PreviewButtonPopup = ({ open, onClose, infoSinistre}) => {
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [claimDetails, setClaimDetails] = useState(null);
    const dispatch = useDispatch();
    const [showAdvanced, setShowAdvanced] = useState(false);

    // claimDetails est un état local (hors store) : les onglets remontent le nouveau statut ici
    const handleStatusChange = (status) => {
        setClaimDetails((prev) => (prev ? { ...prev, status } : prev));
    };

    useEffect(() => {
        const fetchClaimDetails = async () => {
            setLoading(true);
            try {
                const claim = await dispatch(getClaimDetails(infoSinistre));
                setClaimDetails(claim);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        if (open && infoSinistre) {
            fetchClaimDetails();
        }
    }, [dispatch, infoSinistre, open]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <div style={{ width: "100%", background: 'rgba(255, 255, 255, 1)' }}>
                        {children}
                    </div>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="preview-popup-title"
            aria-describedby="preview-popup-description"
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
        >
            <Box
                sx={{
                    width: '85%',
                    height: '100vh',
                    overflow: 'auto',
                    margin: 0,
                    padding: '20px',
                    bgcolor: 'background.paper',
                    position: 'relative',
                    right: 0
                }}
                style = {{backgroundColor: "rgba(249, 249, 249, 1)"}}
            >
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p>Error loading claim details: {error.message}</p>
                ) : claimDetails ? (
                    <>
                        <InformationSinistre showAdvanced={showAdvanced} informationSinistre={claimDetails} />
                        <Tabs value={value} onChange={handleChange} sx={{ marginTop: '40px', variant: 'fullWidth' }}>
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(0)} label="Tiers" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(1)} label="Polices" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(2)} label="Véhicules" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(3)} label="Photos" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(4)} label="Documents" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(5)} label="Expertises" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(6)} label="Prise en charge" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(7)} label="Réglement Honoraires" />
                            <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(8)} label="Mouvements" />
                        </Tabs>
                        <CustomTabPanel value={value} index={0}>
                            <TiersSection listOfParties={claimDetails?.involvedParties} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <PoliceSection listOfPolice={claimDetails?.involvedPolicies} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <VehiculeSection listOfCars={claimDetails?.involvedCars} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}>
                            <ImagesTab claimNumber={claimDetails?.claimNumber} claimStatus={claimDetails?.status} onStatusChange={handleStatusChange} renderUploadPicture={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={4}>
                            <DocSection claimNumber={claimDetails?.claimNumber} claimStatus={claimDetails?.status} onStatusChange={handleStatusChange}
                            reportingNumber = {claimDetails?.additionalData.reportingNumber} 
                            policyNumber={claimDetails?.involvedPolicies[0]?.policyUid} partyUid={claimDetails?.involvedParties[0]?.partyUid}
                                renderUploadDoc={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={5}>
                            <ExpertisesSection claimNumber={claimDetails?.claimNumber} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={6}>
                            <PriseEnChargeSection claimNumber={claimDetails?.claimNumber} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={7}>
                            <ReglementHonorairesSection claimNumber={claimDetails?.claimNumber} renderAsSpans={true} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={8}>
                            <HistoriqueSection claimNumber={claimDetails?.claimNumber} />
                        </CustomTabPanel>
                    </>
                ) : (
                    <p>No information available</p>
                )}
            </Box>
        </Modal>
    );
};

export default PreviewButtonPopup;
